// ✅ RM Return Verification - User B Module
import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";

const RMReturnCapture = () => {
  const [returns, setReturns] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [remarkUpdates, setRemarkUpdates] = useState({});
  const [locationUpdates, setLocationUpdates] = useState({});
  const fetchReturns = async () => {
    try {
      const response = await axiosInstance.get("/api/rm-return");
      setReturns(response.data);
    } catch (error) {
      console.error("Error fetching RM returns:", error);
    }
  };

  useEffect(() => {
    fetchReturns();
  }, []);

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const handleImageUpload = async (e, rowId) => {
    const file = e.target.files[0];
    if (!file || !rowId) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      await axiosInstance.patch(`/api/rm-return/${rowId}/upload-image`, formData);
      showAlert ("Image uploaded successfully","success");
      fetchReturns();
    } catch (err) {
      alert("Failed to upload image");
    }
  };

  // const handleConfirmStatus = async (id) => {
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   try {
  //     await axiosInstance.patch(`/api/rm-return/${id}/confirm-status`, {
  //       ConfirmedBy: user?.Name || "Supervisor"
  //     });
  //     alert("Status updated to Confirmed");
  //     fetchReturns();
  //   } catch (err) {
  //     alert("Failed to update status");
  //   }
  // };

  const handleViewImage = (imagePath) => {
    setSelectedImage(`${axiosInstance.defaults.baseURL}/uploads/${imagePath}`);
    setShowImageModal(true);
  };

   // --- PATCH handlers ---
 // inside RMReturnCapture component

// PATCH handler for Remarks
const handleRemarkUpdate = async (id, value) => {
  try {
    await axiosInstance.patch("/api/rm-return/remarks", { id, remarks: value });
    showAlert("Remarks updated successfully", "success");
    // Optionally refresh data: fetchReturns();
  } catch (err) {
    console.error("❌ Failed to update remarks:", err);
    showAlert("Failed to update remarks", "danger");
  }
};

// PATCH handler for Location
const handleLocationUpdate = async (id, value) => {
  try {
    await axiosInstance.patch("/api/rm-return/location", { id, location: value });
    showAlert("Location updated successfully", "success");
    // Optionally refresh data: fetchReturns();
  } catch (err) {
    console.error("❌ Failed to update location:", err);
    showAlert("Failed to update location", "danger");
  }
};


  const columns = [
     { name: "Department", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.Department}
      >
      {row.Department || "N/A"}
      </span>
    ), sortable: true },
    { name: "LOT ID",width:"190px", selector: (row) =>(
      <span 
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.LOT_ID}
      >
      { row.LOT_ID}
      </span>
    ), sortable: true },
    { name: "Quantity", selector: (row) => row.RM_Quantity, sortable: true },
    { name: "Damage QTY", selector: (row) => row.DamageQTY || "N/A", sortable: true },
    {
      name: "Status",
      selector: (row) => (
        <span
          style={{
            padding: "4px 12px",
            borderRadius: "6px",
            fontWeight: "bold",
            display: "inline-block",
            color:
              row.Status === "Confirmed"
                ? "#155724"
                : row.Status === "Rejected"
                ? "#721c24"
                : "#856404",
            backgroundColor:
              row.Status === "Confirmed"
                ? "#d4edda"
                : row.Status === "Rejected"
                ? "#f8d7da"
                : "#fff3cd"
          }}
        >
          {row.Status}
        </span>
      ),
      sortable: true,
    },     
    { name: "RejectReason", selector: (row) => (
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.RejectReason}
      >
        { row.RejectReason || "N/A"}
      </span>
    ),
    sortable: true },
      // ——— NEW Remarks column ———
    {
      name: "Remarks",
      cell: (row) => (
        <textarea
          className="form-control"
          rows={1}
          value={
            remarkUpdates[row.ID] !== undefined
              ? remarkUpdates[row.ID]
              : row.Remarks || ""
          }
          onChange={(e) =>
            setRemarkUpdates((prev) => ({
              ...prev,
              [row.ID]: e.target.value,
            }))
          }
          onBlur={(e) => handleRemarkUpdate(row.ID, e.target.value)}
          placeholder="Enter remarks"
          style={{ fontSize: "12px" }}
        />
      ),
      sortable: false,
    },

    // ——— NEW Location column ———
    // {
    //   name: "Location",
    //   cell: (row) => (
    //     <input
    //       type="text"
    //       className="form-control"
    //       value={
    //         locationUpdates[row.ID] !== undefined
    //           ? locationUpdates[row.ID]
    //           : row.Location || ""
    //       }
    //       onChange={(e) =>
    //         setLocationUpdates((prev) => ({
    //           ...prev,
    //           [row.ID]: e.target.value,
    //         }))
    //       }
    //       onBlur={(e) => handleLocationUpdate(row.ID, e.target.value)}
    //       placeholder="Enter location"
    //       style={{ fontSize: "12px" }}
    //     />
    //   ),
    //   sortable: false,
    // },
    {
  name: "Location",
  cell: (row) => {
    const currentValue =
      locationUpdates[row.ID] !== undefined
        ? locationUpdates[row.ID]
        : row.Location || "";

    return (
      <select
        className="form-select form-select-sm"
        value={currentValue}
        onChange={async (e) => {
          const newLoc = e.target.value;
          // update local state
          setLocationUpdates((prev) => ({
            ...prev,
            [row.ID]: newLoc,
          }));
          // push to server
          await handleLocationUpdate(row.ID, newLoc);
        }}
        style={{ fontSize: "12px" }}
      >
        <option value="">Select Location</option>
        <option value="BKB 7">BKB 7</option>
        <option value="BKB 8">BKB 8</option>
        <option value="BKB 9">BKB 9</option>
        <option value="BKB 10">BKB 10</option>
        <option value="BKB 11">BKB 11</option>
        <option value="BKB 12">BKB 12</option>
        <option value="BKB 13">BKB 13</option>
        <option value="BKB 14">BKB 14</option>
        <option value="BKB 15">BKB 15</option>
        <option value="BKB 16">BKB 16</option>
        <option value="BKB 17">BKB 17</option>
        <option value="BKB 18">BKB 18</option>
        <option value="GF 1">GF 1</option>
         <option value="GF 2">GF 2</option>
          <option value="GF 3">GF 3</option>
          
      </select>
    );
  },
  sortable: false,
},
    //end
    {
      name: "Image",
      cell: (row) => (
        row.ImagePath ? (
          <button
            className="btn btn-sm btn-outline-info"
            onClick={() => handleViewImage(row.ImagePath)}
          >
            View
          </button>
        ) : (
          <>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              style={{ display: "none" }}
              id={`capture-${row.ID}`}
              onChange={(e) => handleImageUpload(e, row.ID)}
            />
            <label htmlFor={`capture-${row.ID}`} className="btn btn-sm btn-outline-secondary">
              Capture
            </label>
          </>
        )
      ),
    },
  
     {
      name: "Date",
      selector: (row) => new Date(row.CreatedAt).toLocaleString("en-GB"),
      sortable: true
    },
    // {
    //   name: "Actions",
    //   cell: (row) =>
    //     row.Status === "Confirmed" ? (
    //       <div className="approved-wrapper" title="Already Approved">
    //         <button
    //           className="btn btn-sm btn-success"
    //           disabled
    //           style={{ cursor: "not-allowed", opacity: 0.6 }}
    //         >
    //           Approved
    //         </button>
    //       </div>
    //     ) : (
    //       <button
    //         className="btn btn-sm btn-success"
    //         onClick={() => handleConfirmStatus(row.ID)}
    //       >
    //         Approve
    //       </button>
    //     )
    // }
    
    
  ];

  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${type === "success" ? "Success!" : "Error!"}</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 2000);
  };
  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{height:"-webkit-fill-available"}}>
          <h4 className="mb-4">RM Return</h4>
          <DataTable columns={columns} data={returns} pagination />
        </main>
      </div>

      {/* View Image Modal */}
      {showImageModal && (
          <>
          {/* Bootstrap Backdrop */}
         <div className="modal-backdrop fade show"></div>
 
         {/* Bootstrap Modal */}
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Returned RM Image</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowImageModal(false)}
                ></button>
              </div>
              <div className="modal-body text-center">
                {selectedImage ? (
                  <img
                    src={selectedImage}
                    alt="Returned RM"
                    style={{ maxWidth: "100%", maxHeight: "500px" }}
                  />
                ) : (
                  <p>No image available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
        </>
      )}
    </div>
  );
};

export default RMReturnCapture;
